import { Component, OnInit } from '@angular/core';
import { PaymentService } from '../../../_services/subscription/payment.service';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../../../_services/loader.service';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../_services/auth.service';

@Component({
  selector: 'app-payment-status',
  imports: [CommonModule, RouterModule],
  templateUrl: './payment-status.component.html',
  styleUrl: './payment-status.component.scss',
})
export class PaymentStatusComponent implements OnInit {
  status: 'COMPLETED' | 'FAILED' | 'PENDING' = 'PENDING';
  transactionId: any;
  amount: number = 0;
  transactionData: any = {};
  transactionDetails: any = {};
  constructor(private _SPS: PaymentService, private loader: LoaderService, private router: Router,private _authService : AuthService) {}

  ngOnInit(): void {
    this.loader.show();
    const transactionId: any = JSON.parse(
      localStorage.getItem('subpaymentData') || '{}'
    );
    if (transactionId) {
      this.transactionData = transactionId
      this.verifyPayment(transactionId.transactionId);
    }
  }
  data: any = {};

  private static readonly STATUS_MAP: Record<string, 'COMPLETED' | 'FAILED' | 'PENDING'> = {
    PAID: 'COMPLETED',
    EXPIRED: 'FAILED',
    CANCELLED: 'FAILED',
    ACTIVE: 'PENDING',
    PENDING: 'PENDING',
  };

  verifyPayment(orderId: string) {
    this._SPS.verifyCPGPayment(orderId).subscribe({
      next: (res: any) => {
        this.transactionDetails = {
          transactionId: res.orderId,
          amount: res.amount,
          paymentMode: res.paymentMethod,
          timestamp: res.paidAt,
          status: res.status,
          invoice: res.invoiceNo ? { invoiceNo: res.invoiceNo } : undefined,
        };

        if (res.status === 'PAID') {
          // Backend has just granted the subscription — refresh the cached
          // profile so the rest of the app (header, gating, etc.) sees the
          // upgrade without needing a full reload.
          this._authService.getUserProfile().subscribe((user: any) => this._authService.setUser(user));
        }

        this.show(
          PaymentStatusComponent.STATUS_MAP[res.status] ?? 'PENDING',
        );
        localStorage.removeItem('subpaymentData');
        this.loader.hide();
      },
      error: (err: any) => {
        this.loader.hide();
        console.error('Verification failed:', err);
      },
    });
  }

  activeTab: any = '';
  show(type: 'COMPLETED' | 'FAILED' | 'PENDING') {
    this.activeTab = type;
    ['COMPLETED', '"FAILED"', 'PENDING'].forEach((t) => {
      const view = document.getElementById('view-' + t);
      const tab = document.getElementById('tab-' + t);
      if (view) view.style.display = t === type ? 'block' : 'none';
      if (tab) tab.className = 'tab-btn' + (t === type ? ' active-' + t : '');
    });
  }
  downloadReceipt() {
    if (!this.transactionDetails.invoice?.invoiceNo) {
      console.error('No invoice available for this transaction yet');
      return;
    }
    this.loader.show()
    this._SPS.downloadReceipt(this.transactionDetails.invoice.invoiceNo).subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `receipt-${this.transactionDetails.transactionId}.pdf`;
        document.body.appendChild(a);
        a.click();
        this.loader.hide()
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error: (err) => {
        console.error('Download failed', err);
      }
    });
  }
  gotoProperty(){
    this.router.navigate(['/search'])
  }
}
